var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictoPrix(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.721,
    height: 14.865,
    viewBox: "0 0 13.721 14.865",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#616a7d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M28.931,11.769A4.373,4.373,0,0,1,25.765,13.2a4.833,4.833,0,0,1-4.334-3.274h5.3a.832.832,0,1,0,0-1.663H21.008a6.958,6.958,0,0,1-.051-.832,6.875,6.875,0,0,1,.064-.936h5.7a.832.832,0,0,0,0-1.663H21.475a4.807,4.807,0,0,1,4.29-3.17A4.373,4.373,0,0,1,28.931,3.1a.832.832,0,0,0,1.206-1.146A6.018,6.018,0,0,0,25.766,0,6.589,6.589,0,0,0,19.7,4.834H17.476a.832.832,0,0,0,0,1.663h1.872a8.559,8.559,0,0,0-.053.936c0,.281.015.558.042.832H17.476a.832.832,0,0,0,0,1.663h2.2a6.606,6.606,0,0,0,6.095,4.938,6.018,6.018,0,0,0,4.371-1.949.832.832,0,0,0-1.205-1.146Z",
    transform: "translate(-16.644)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPrix);
export default __webpack_public_path__ + "static/media/picto_prix.770d2da1.svg";
export { ForwardRef as ReactComponent };